import type { JSX } from 'react';

import { Box, alpha, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

// STORNO status chip (CHR-02 / ADR-0039 / zadání §6b). Theme `error` palette
// token only (no raw hex). Shared by the desktop table and the mobile card
// trees so both render the identical pill. The whole-row red tint that
// accompanies it (also via `error.main`) lives on each row container.
export const STORNO_ROW_TINT_ALPHA = 0.12;

export const StornoChip = (): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation('orders');
  return (
    <Box
      component="span"
      data-testid="storno-chip"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        bgcolor: alpha(theme.palette.error.main, 0.16),
        color: theme.palette.error.main,
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{ width: 6, height: 6, borderRadius: 999, bgcolor: 'currentColor' }}
      />
      {t('storno.chip')}
    </Box>
  );
};
